<template>
  <PageTemplate>
    <h1>Manage My Subscriptions</h1>
    <div>
      <v-card
        :padded="false"
        title="Subscription / Notification settings for new and updated Publications"
      >
        <section class="file-system">
          <div
            class="file-system__col"
            :class="{'file-system__col--selected': category_id}"
          >
            <v-category
              v-for="(category, index) in categories"
              :key="index"
              :checked="category_id === category.id"
              @click="checkCategory(category.id)"
            >
              {{ category.name }}
            </v-category>
          </div>
          <div
            class="file-system__col"
            :class="{'file-system__col--selected': folder_id}"
          >
            <div
              v-if="category_id && subCategories.length > 0"
              class="file-system__header file-system__header--dark"
            >
              <div class="file-system__header-col">
                <v-checkbox
                  id="subscribe-all"
                  class="file-system__all"
                  :checked="checkSubscribeAll"
                  @change="subscribeAll"
                >
                  Subscribe to all
                </v-checkbox>
              </div>
              <div
                v-if="checkSubscribeAll"
                class="file-system__header-col"
              >
                Email notifications: &nbsp;
                <v-toggle
                  id="toggle"
                  v-model="checkNotifyAll"
                  @change="notifyAll"
                />
              </div>
            </div>
            <div class="file-system__body">
              <div
                v-if="category_id"
                class="file-system__nav"
              >
                <button
                  class="file-system__back"
                  @click="clearCategory"
                >
                  <v-icon type="angle-left" />
                </button>
                <v-category checked>
                  {{ categories.find(x => x.id === category_id).name }}
                </v-category>
              </div>
              <v-subscription
                v-for="(subCat, index) in subCategories"
                :id="subCat.id"
                :key="index"
                :title="subCat.name"
                :is-subscribe="subCat.isSubscribe"
                :is-notify="subCat.isNotify"
                :is-selected="folder_id === subCat.id"
                @click="setFolder(subCat.id)"
                @subscribe="subscribeSingle"
                @notify="notifySingle"
              />
            </div>
          </div>
          <div
            v-if="folder_id"
            class="file-system__col"
          >
            <div
              class="file-system__nav"
            >
              <button
                class="file-system__back"
                @click="clearSubcategory"
              >
                <v-icon type="angle-left" />
              </button>
              <v-subscription
                :title="subCategories.find(x => x.id === folder_id).name"
                is-selected
              />
            </div>
            <div
              v-show="publications.length > 0"
              class="file-system__header"
            >
              <h5 class="file-system__title">
                Specific Accreditation Criteria
              </h5>
            </div>
            <div
              class="file-system__body"
            >
              <template v-if="publications.length > 0">
                <v-document
                  v-for="(document, index) in publications"
                  :key="index"
                  class="file-system__document"
                  :title="document.name"
                  :link="document.id.toString()"
                  @click="downloadDoc"
                />
              </template>
              <div
                v-else
                class="file-system__message"
              >
                No documents available!
              </div>
            </div>
          </div>
        </section>
      </v-card>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import Toggle from "@/atoms/Toggle";
  import Document from "@/molecules/Document";
  import Subscription from "@/molecules/Subscription";
  import Category from "@/molecules/Category";
  import Card from "@/molecules/Card";
  import Checkbox from "@/atoms/Checkbox";
  import Icon from "@/atoms/Icon";
  import {mapState} from "vuex";
  import {buildBreadCrumb} from "@/common/tableFunctions";
  import routes from "@/common/routes";
  import {
    GET_SUBSCRIPTION_CATEGORY,
    CLEAR_CATEGORY_FOLDER,
    SET_CATEGORY_FOLDER,
    CLEAR_SUBCATEGORY_FOLDER,
    SET_SUBCATEGORY_PUBLICATION,
    ADD_PUBLICATION_SUBSCRIPTION,
    DELETE_PUBLICATION_SUBSCRIPTION,
    ADD_PUBLICATION_NOTIFICATION,
    DELETE_PUBLICATION_NOTIFICATION,
    CLEAR_SUBSCRIPTION_PUBLICATIONS,
    DOWNLOAD_PUBLICATION,
  } from "../store/actions.type";

  export default {
    name: "Subscriptions",
    components: {
      "v-checkbox": Checkbox,
      "v-document": Document,
      "v-toggle": Toggle,
      "v-subscription": Subscription,
      "v-category": Category,
      "v-card": Card,
      "v-icon": Icon,
      PageTemplate,
    },
    data: () => ({
      checkSubscribeAll: false,
      checkNotifyAll: false,
    }),
    watch:{
      category_id:function(val){
        this.checkSubscribeAll = this.subCategories.length === this.subCategories.filter(el => el.isSubscribe === true).length;
        this.checkNotifyAll = this.subCategories.length === this.subCategories.filter(el => el.isNotify === true).length;
      },
      subCategories:{
        deep:true,
        handler:function(val){
          this.checkSubscribeAll = val.length === val.filter(el => el.isSubscribe === true).length;
          this.checkNotifyAll = val.length === val.filter(el => el.isNotify === true).length;
        }
      }
    },
    computed: {
      ...mapState({
        publications: state => state.subscription.publications,
        folder_id: state => state.subscription.folderId,
        category_id: state => state.subscription.category_id,
        categories: state => state.subscription.categories,
        subCategories: state => state.subscription.subCategories,
      }),
    },
    mounted() {
      this.updateBreadCrumb();
      this.getCategory();
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Publications'] = routes.PUBLICATIONS;
        breadcrumbs['Manage Subscriptions'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getCategory() {
        this.$store.dispatch(GET_SUBSCRIPTION_CATEGORY).then(response => {
          if (this.category_id != null) {
            this.$store.dispatch(SET_CATEGORY_FOLDER, this.category_id);
          }
          if (this.folder_id != null) {
            this.$store.dispatch(SET_SUBCATEGORY_PUBLICATION, this.folder_id);
          }
        })
      },
      clearCategory() {
        this.$store.dispatch(CLEAR_CATEGORY_FOLDER);
      },
      clearSubcategory() {
        this.$store.dispatch(CLEAR_SUBCATEGORY_FOLDER);
      },
      checkCategory(category_id) {
        this.$store.dispatch(CLEAR_SUBSCRIPTION_PUBLICATIONS);
        this.$store.dispatch(CLEAR_SUBCATEGORY_FOLDER);
        this.$store.dispatch(SET_CATEGORY_FOLDER, category_id);
      },
      setFolder(folderId) {
        this.$store.dispatch(SET_SUBCATEGORY_PUBLICATION, folderId)
      },
      subscribeAll(e) {
        let subscribeList = this.subCategories
          .filter(el => el.isSubscribe === !e.target.checked)
          .map(function (obj) {
            return obj.id;
          });
        if (subscribeList.length > 0) {
          if (e.target.checked) {
            this.sub(subscribeList)
          }
          else {
            this.unsub(subscribeList)
          }
        }
      },
      sub(idList) {
        this.$store.dispatch(ADD_PUBLICATION_SUBSCRIPTION, idList)
          .then(response => {
            if (!response.success) {
              this.$notify({
                title: 'Error:',
                text: response.response.data.message,
                type: 'error'
              })
            }
            this.getCategory();
          })
      },
      unsub(idList) {
        this.$store.dispatch(DELETE_PUBLICATION_SUBSCRIPTION, idList)
          .then(response => {
            if (!response.success) {
              this.$notify({
                title: 'Error:',
                text: response.response.data.message,
                type: 'error'
              })
            }
            this.getCategory();
          });
      },
      subscribeSingle([id, isSubscribed]) {
        var category_ids = [];
        if (id) {
          category_ids.push(id)
          if (isSubscribed) {
            this.unsub(category_ids)
          }
          else {
            this.sub(category_ids)
          }
        }
      },
      notify(idList) {
        this.$store.dispatch(ADD_PUBLICATION_NOTIFICATION, idList)
          .then(response => {
            if (!response.success) {
              this.$notify({
                title: 'Error:',
                text: response.response.data.message,
                type: 'error'
              })
            }
            this.getCategory();
          });
      },
      unnotify(idList) {
        this.$store.dispatch(DELETE_PUBLICATION_NOTIFICATION, idList)
          .then(response => {
            if (!response.success) {
              this.$notify({
                title: 'Error:',
                text: response.response.data.message,
                type: 'error'
              })
            }
            this.getCategory();
          });
      },
      notifyAll(e) {
        let notifyList = this.subCategories
          .filter(el => el.isNotify === !e)
          .map(function (obj) {
            return obj.id;
          });
        if (notifyList.length > 0) {
          if (e) {
            this.notify(notifyList)
          }
          else {
            this.unnotify(notifyList)
          }
        }
      },
      notifySingle([id, isNotify]) {
        let category_ids = [];
        category_ids.push(id)
        if (isNotify) {
          this.unnotify(category_ids);
        } else {
          this.notify(category_ids);
        }
      },
      downloadDoc: function (params) {
        let id = params;
        this.$store.state.auth.isLoading = true;
        this.$store.dispatch(DOWNLOAD_PUBLICATION, {id})
          .then(response => {
            return response;
          }).finally(() => {
            this.$store.state.auth.isLoading = false;
          });
      },
    }
  }
</script>
